import {
  ComponentTypeFactory,
  FieldTypeFactory,
} from '@sentecacommerce-theme/base'
import { BasketProps } from './basket.props'

export const BasketType = ComponentTypeFactory.create<BasketProps>('Basket', {
  title: FieldTypeFactory.text({ required: true }),
  isDev: FieldTypeFactory.boolean({ required: false }),
  labels: {
    totalWithoutDiscount: FieldTypeFactory.text({ required: true }),
    totalDiscount: FieldTypeFactory.text({ required: true }),
    total: FieldTypeFactory.text({ required: true }),
    continueToCheckout: FieldTypeFactory.text({ required: true }),
    emptyBasketText: FieldTypeFactory.text(),
    emptyBasketCallToAction: FieldTypeFactory.text(),
    continueWithShopping: FieldTypeFactory.text(),
    addedToBasketText: FieldTypeFactory.text(),
    fixedDeliveryPrice: FieldTypeFactory.text(),
    freeDeliverySentence: {
      start: FieldTypeFactory.text(),
      middlePart: FieldTypeFactory.text(),
      end: FieldTypeFactory.text(),
    },
    productNumberLabel: FieldTypeFactory.text({
      required: true,
      label: 'Product Number Label',
      defaultValue: 'Продуктов номер',
    }),
    products: FieldTypeFactory.text({
      required: true,
      label: 'Products Label',
    }),
  },
})
